import { ReactElement, useContext } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { ShowcaseProvider } from '../../providers/ShowcaseProvider';
import { NavigationCore } from '../components';

import { AuthorizedPageLayout } from ':components';
import { AuthContext } from ':constants';

export const Layout = (): ReactElement => {
  const { auth } = useContext(AuthContext);

  return auth ? (
    <ShowcaseProvider>
      <AuthorizedPageLayout>
        <NavigationCore />
        <Outlet />
        <ScrollRestoration />
      </AuthorizedPageLayout>
    </ShowcaseProvider>
  ) : (
    <>Что-то определённо пошло не так как мы планировали..</>
  );
};
